/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import FilterAndSortBarWithActions from '@/components/listings/FilterAndSortBarWithActions'
import { Button, Flex, useBreakpointValue } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { assetLicenseBatchesUrls } from '@/configs/urls'
import { LICENSE_MULTIPLE_ASSETS } from '@/configs/strings/asset-licenses.strings'
import { useResponsive } from '@/hooks/useResponsive'

const Header = ({
  filterOptions,
  onFilterResults,
  onReset,
  searchParams,
  sortOptions
}) => {
  const { flexReverseDirection, flexGap } = useResponsive()
  const borderButton = useBreakpointValue({
    base: 'pb-5 mb-5 border-b border-[#D0D0D0] text-center',
    md: ''
  })

  return (
    <Flex
      justifyContent="space-between"
      flexDirection={flexReverseDirection}
      gap={flexGap}
    >
      <FilterAndSortBarWithActions
        currentValues={searchParams}
        filterOptions={filterOptions}
        onFilterResults={onFilterResults}
        onReset={onReset}
        searchResultsKeyData="data"
        searchResultsKeyLabel="name"
        searchResultsKeyValue="name"
        sortOptions={sortOptions}
      />
      <div className={borderButton}>
        <Button
          as={Link}
          to={`/${assetLicenseBatchesUrls.base}`}
        >
          { LICENSE_MULTIPLE_ASSETS }
        </Button>
      </div>
    </Flex>
  )
}

export default Header
